export default class Service {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        serviceRetrieve(id: ${id}) {
          id
          name
          description
          dateStart
          price
          active
          formAfiliate         
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.serviceRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        serviceList {
          results {
            id
            name
            description
            dateStart
            price
            active
            formAfiliate           
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    return response.data.data.serviceList.results.reverse();
  }

  // static async filter(axios, region) {
  //   const response = await axios.post(
  //     '/graphql/',
  //     `query{
  //       cityList (region: ${region}){
  //         results {
  //           id
  //           name
  //           latitude
  //           longitude
  //           region {
  //             id
  //             name
  //           }
  //         }
  //       }
  //     }`,
  //     {
  //       headers: {
  //         'Content-Type': 'application/graphql'
  //       }
  //     }
  //   );
  //   return response.data.data.cityList.results.reverse();
  // }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteService(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteService.ok;
  }

  static async create(axios, name, description, dateStart, price, active, formAfiliate) {
    const desc = description !== null ? `description: ${JSON.stringify(description)},`: ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        createService(newService: {
          name: "${name}", 
          ${desc}
          dateStart: "${dateStart}",
          price: ${price},
          active: ${active},
          formAfiliate:${formAfiliate}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createService.ok;
  }


  static async edit(axios, id, name, description, dateStart, price, active, formAfiliate) {
    const desc = description !== null ? `description: ${JSON.stringify(description)},`: ``;

    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateService(newService: {
          id: ${id},
          name: "${name}", 
          ${desc}
          dateStart: "${dateStart}",
          price: ${price},
          active: ${active},
          formAfiliate:${formAfiliate}
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateService.ok;
  }

}
